import { message, Select } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    ModalItem,
    FormItem,
    InputItem,
    ButtonItem,
    ErrorItem,
    DatePickerItem,
    SelectItem,
} from "../../../../Components/Items";
import SelectEmpleadosItem from "../../../../Components/SelectEmpleadosItem";
import SelectRelojesChecadoresItem from "../../../../Components/SelectRelojesChecadoresItem";

const { Option } = Select;

class AgregarAsistencia extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
    };
    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible)
            this.consultarTodo();
    }
    cerrarAgregarAsistencia(codigo) {
        this.props.cerrarAgregarAsistencia(codigo);
    }
    async consultarTodo() {
        this.setState({ loading: true });
        await axios
            .post(
                "proyectos/selectProyectos",
                { empresaId: this.props.empresaId },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.status === 404) {
                } else {
                    this.setState({
                        todasProyectos: res.data,
                        objetoProyectos: res.data.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                    });
                }
            });
        this.setState({ loading: false });
    }
    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        this.setState({ loading: true });
        axios
            .post(
                "asistencias/agregarAsistencia",
                { ...values, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha registrado una asistencia");
                    this.formRef.current.resetFields();
                    this.cerrarAgregarAsistencia(res.data.codigo);
                } else if (res.data.success === 1) {
                    message.error("No se puede registrar la asistencia");
                } else {
                    message.error("Hubo un error y la asistencia no se registro");
                }
            });
    }
    render() {
        return (
            <>
                <ModalItem
                    title="Agregar Asistencia"
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={this.cerrarAgregarAsistencia.bind(this)}
                    paddingTop
                >
                    <Form
                        ref={this.formRef}
                        name="agregarAsistencia"
                        layout
                        bottom={
                            <ButtonItem
                                type="primary"
                                htmlType="submit"
                                style={{ display: "block", margin: "0 0 0 auto" }}
                            >
                                Agregar
                            </ButtonItem>
                        }
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <FormItem
                            name="entrada"
                            label="Estado de asistencia"
                            margin
                            required
                        >
                            <SelectItem placeholder="Estado de asistencia">
                                <Option value={0}>Entrada</Option>
                                <Option value={1}>Salida</Option>
                                <Option value={2}>Entrada a descanso</Option>
                                <Option value={3}>Salida de descanso</Option>
                                <Option value={4}>Entrada de T.E.</Option>
                                <Option value={5}>Salida de T.E.</Option>
                                <Option value={6}>Sin estado</Option>
                            </SelectItem>
                        </FormItem>
                        <FormItem
                            label="Fecha"
                            name="fechaAsistencia"
                            required
                            margin
                        >
                            <DatePickerItem
                                placeholder="Fecha"
                                showTime
                                dateFormat='DD/MM/YYYY HH:mm'
                            />
                        </FormItem>
                        <FormItem
                            label="Reloj Checador"
                            name="relojChecadorId"
                            fieldKey="relojChecadorId"
                            margin
                        >
                            <SelectRelojesChecadoresItem
                                empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                headersToken={this.props.headersToken}
                                sinBorde
                                autoFocus
                                dropdownMatchSelectWidth={600}
                                width="100%"
                                placeholder="Reloj Checador"
                            />
                        </FormItem>
                        <FormItem
                            label="Empleado"
                            name="empleadoId"
                            fieldKey="empleadoId"
                            margin
                        >
                            <SelectEmpleadosItem
                                empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                headersToken={this.props.headersToken}
                                sinBorde
                                autoFocus
                                dropdownMatchSelectWidth={600}
                                width="100%"
                                placeholder="Empleado"
                            />
                        </FormItem>
                        <FormItem
                            label="Proyecto"
                            name="proyectoId"
                            margin
                            required
                        >
                            <SelectItem placeholder="Proyecto">
                                {this.state.objetoProyectos}
                            </SelectItem>
                        </FormItem>
                        <FormItem
                            name="observaciones"
                            label="Observaciones"
                            required
                            max={100}
                            margin
                            pattern
                        >
                            <InputItem placeholder="Observaciones" />
                        </FormItem>
                    </Form>
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(AgregarAsistencia);
